import Rover from '@rover/globals/Rover';

function toggle() {
  Rover.views.HeaderNavBarView.hideAllServices();

  if ($('.js-how-it-works').hasClass('in')) {
    $('.js-how-it-works').removeClass('in');
  } else {
    $('.js-how-it-works').addClass('in');
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      400
    );
  }
}

export default {
  toggle,
};



// WEBPACK FOOTER //
// ../utilities/how-it-works.js